import { getDefaultProductMaintenanceDetails } from '../actions/threePlProductMaintenanceActions'

// import _ from 'lodash';
const threePlProductMaintenance = {
  list: {},
  detail: null,
  newForm: getDefaultProductMaintenanceDetails(0),
  isLoading: {
    list: false,
    modal: false,
    form: false,
  },
}
const ThreePlProductMaintenanceReducer = function (state = threePlProductMaintenance, action) {
  switch (action.type) {
    case 'TOGGLE_THREE_PL_PRODUCT_MAINTENANCE_LOADING': {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.key]: action.value,
        },
      }
    }
    case 'UPDATE_THREE_PL_PRODUCT_MAINTENANCE_LIST': {
      let newList = {}
      Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.list[key], ...value }))
      return {
        ...state,
        list: {
          ...state.list,
          ...newList,
        },
      }
    }
    case 'UPDATE_THREE_PL_PRODUCT_MAINTENANCE_DETAIL': {
      return {
        ...state,
        detail: {
          ...state.detail,
          ...action.detail,
        },
      }
    }
    case 'CHANGE_THREE_PL_PRODUCT_MAINTENANCE_DETAIL': {
      const newDetail = {
        ...state.detail,
        [action.key]: action.value,
      }

      return {
        ...state,
        detail: newDetail,
      }
    }
    case 'CHANGE_THREE_PL_PRODUCT_MAINTENANCE_DETAIL_BULK': {
      return {
        ...state,
        detail: {
          ...state.detail,
          ...action.values,
        },
      }
    }
    case 'CHANGE_THREE_PL_PRODUCT_MAINTENANCE_NEW_FORM': {
      const newDetail = {
        ...state.newForm,
        [action.key]: action.value,
      }

      return {
        ...state,
        newForm: newDetail,
      }
    }
    case 'CHANGE_THREE_PL_PRODUCT_MAINTENANCE_NEW_FORM_BULK': {
      return {
        ...state,
        newForm: {
          ...state.newForm,
          ...action.values,
        },
      }
    }
    case 'RESET_THREE_PL_PRODUCT_MAINTENANCE_NEW_FORM_BULK': {
      return {
        ...state,
        newForm: getDefaultProductMaintenanceDetails(0),
      }
    }
    default: {
      return state
    }
  }
}

export default ThreePlProductMaintenanceReducer
